import { Button, Modal } from 'react-bootstrap';
import { useEffect, useState } from 'react';

const LS_KEY = 'provisional_notice_shown_at';
const MS_72H = 72 * 60 * 60 * 1000;

const shouldShow = (): boolean => {
    if (!location.hostname.includes('localhost')) {
        return false;
    }
    const stored = localStorage.getItem(LS_KEY);
    if (!stored) {
        return true;
    }
    return Date.now() - Number(stored) >= MS_72H;
}

export const TemporaryNotice = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        // if (shouldShow()) {
        //     localStorage.setItem(LS_KEY, String(Date.now()));
        //     setShow(true);
        // }
    }, []);

    if (!show) {
        return <></>;
    }

    return (
        <Modal show={show} size={'lg'} onHide={() => setShow(false)} centered>
            <Modal.Header closeButton className={'bg-dark text-white border-secondary'}>
                <Modal.Title>
                    ⚠️ Aviso importante
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={'bg-dark text-white'}>
                <p>
                    
                </p>
            </Modal.Body>
            <Modal.Footer className={'bg-dark border-secondary'}>
                <Button variant={'outline-light'} onClick={() => setShow(false)}>
                    Entendido
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
